<div>
  <app-alert
    style="margin-bottom: 32px"
    class="flex-col-container my-8"
    type="warning"
    icon="warning_amber"
    lineHeight="lh-1"
    [message]="getWarningMessage() | translate"></app-alert>
  <p class="my-10">{{ 'MODAL_EXONERATION_PJ.ACCOUNT_TO_EXONERATE' | translate}}</p>

  <div class="p-16 flex-row-container items-center b-0-5 rounded">
    <img class="mr-8" src="assets/svg/account_exoneration.svg" alt="rappi logo" />
    <div class="flex-col-container start flex-1 ml-4">
      <span class="fw-500">{{ 'MODAL_EXONERATION_PJ.ACCOUNT_NUMBER' | translate}}</span>
      <span>{{account.external_number}}</span>
    </div>
    <app-read-only
      [descColor]="accountInfo?.is_gmf ? 'success' : 'warning'"
      [applyBorderBottom]="false"
      [value]="(accountInfo?.is_gmf ? 'BANKING_ACCOUNT.DETAIL.GMF_EXEMPTED' : 'BANKING_ACCOUNT.DETAIL.GMF_NOT_EXEMPTED') | translate"></app-read-only>
  </div>

  <!-- Exoneration Type Selection -->
  <div class="mt-32 mb-32">
    <h3 class="fw-600 mb-16">{{ 'MODAL_EXONERATION_PJ.EXONERATION_TYPE' | translate }}</h3>
    <!-- QA-FRIENDLY: Same checkbox interface for both exonerated and unexonerated accounts -->
    <form [formGroup]="exonerationForm">
      <div class="flex-col-container options-container">
        <div *ngFor="let type of gmfReasonTypes"
            class="flex-row-container items-center justify-between p-12 option-item"
            [class.selected]="selectedExonerationType === type.value"
            [class.disabled-option]="isCheckboxDisabled(type.value)">
          <span class="fw-500">{{ type.label }}</span>
          <mat-checkbox 
            [checked]="selectedExonerationType === type.value"
            [disabled]="isCheckboxDisabled(type.value)"
            color="primary"
            (change)="onCheckboxChange($event, type.value)"
            [disableRipple]="true">
          </mat-checkbox>
        </div>
      </div>
    </form>
  </div>
</div>
